export const getIsHubSpotter = userInfo => {
  var _userInfo$user;
  return userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.emails) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.some(email => /@hubspot\.com$/.test(email));
};